
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div id="footer" className="footer">
      <div className="footer2 wow animate__animated animate__fadeIn" id="app">
        Hablemos.
      </div>
      <div className="footer-links-column wow animate__animated animate__fadeIn">
        <a href="mailto:info@elementalvalue.co" className="footer-link-item">info@elementalvalue.co</a>
        <div className="footer-separator"></div>
        <Link to="/aviso-legal" className="footer-link-item">Aviso legal</Link>
        <Link to="/politica-privacidad" className="footer-link-item">Política de privacidad</Link>
        <Link to="/politica-cookies" className="footer-link-item">Política de cookies</Link>
      </div>
      <div className="linkedin">
        <a href="https://www.linkedin.com/company/elementalvalue-co/">
          <img src="/img/linkedin.png" alt="LinkedIn" />
        </a>
      </div>
      <div className="bottom-logo wow animate__animated animate__fadeIn">
        <img src="/img/ev.svg" alt="Elemental Value" />
      </div>
    </div>
  );
};

export default Footer;
